import { Component } from '@angular/core';

@Component({
  selector: 'app-experiencia-cliente',
  templateUrl: './experiencia-cliente.component.html',
  styleUrls: ['./experiencia-cliente.component.scss']
})
export class ExperienciaClienteComponent { }
